import { createGlobalStyle, css } from 'styled-components';
import { normalize } from 'styled-normalize';
import { buttonVariablesCss } from './components/button/button-styles';
import { typographyVariablesCss } from './components/typography/typography-variables';
/**
 * @description Firefox does not support -webkit-scrollbar, a fallback using scrollbar-width is necessary
 * see https://developer.mozilla.org/en-US/docs/Web/CSS/::-webkit-scrollbar
 */
export const scrollbars = css `
  // Firefox
  @-moz-document url-prefix() {
    * {
      scrollbar-width: thin;
      scrollbar-color: ${({ theme }) => `${theme.color.white[13]} ${theme.color.white[11]}`};
    }
  }

  // Webkit
  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    background: transparent;
  }

  ::-webkit-scrollbar-corner {
    display: none;
  }

  ::-webkit-scrollbar-track,
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.color.white[11]};

    border-radius: 4px;
  }

  ::-webkit-scrollbar-track:hover,
  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.color.white[13]};
  }
`;
export const GlobalStyles = createGlobalStyle `
  ${normalize}
  ${scrollbars}
  ${buttonVariablesCss}
  :root {
    ${typographyVariablesCss}
  }

  * {
    box-sizing: border-box;
    outline: none;
    -webkit-tap-highlight-color: transparent;
  }
  
  body {
    font-family: ${(props) => props.theme.fontFamily};
    color: var(--text-12);
  }

  h1, h2, h3, h4, h5, h6, p, input, textarea, button, label, a, span {
    margin: 0;
    padding: 0;
  }

  p {
    font-weight: ${(props) => props.theme.fontWeight.medium};
    font-size: ${(props) => props.theme.fontSize.m};
  }
  
  input, button, textarea {
    font-family: inherit;
  }

`;
//# sourceMappingURL=global-style.js.map